export function windowSize() {
    var p = 720, h = window.innerHeight, w = window.innerWidth, d;
    d = ((w < p && h > w) || (w > p && h > w) || (w < p && h < w)) ? 'mobile' : 'desktop';
    return { h: h, w: w, d: d };
}
